/*
 * @Author: xiwl
 * @Date: 2022-03-14 14:12:34
 * @LastEditors: xiwl
 * @LastEditTime: 2022-04-06 10:09:41
 * @Descripttion: file content
 */
import Login from '../components/login';
import Agreement from "../components/agreement";

const routers = [
    {
        path:'/',
        component: Login
    },
    {
        path:'/login',
        component: Login
    },
    {
        path:'/agreement',
        component: Agreement
    }
]
export default routers
